// extracted by mini-css-extract-plugin
export default {"tab":"BasicTabs_tab__Ci1+r","Mui-selected":"BasicTabs_Mui-selected__U4TVK"};